<template lang="pug">
  modal(@closeModal='closeModal' :title='$t("orderResourcesModal.title")')
    h2.m-top-2.m-bottom-2.dark-gray.text-normal {{ $t("orderResourcesModal.dragToOrder") }}
    draggable.resources(v-model='resources' ghost-class='ghost')
      .resource.row.middle(
        v-for='(resource, index) in resources'
        :key='resource.id'
      )
        h2.name.text-small.gray.m-right-1 {{ index + 1 }}
        h2.name.text-normal.ellipsis(:title='resource.name') {{ resource.name || $t('resourceCard.untitled') }}
        simple-svg.gray-icon.m-left-auto(:filepath='dragIcon' width='16px' height='16px')
    .row.middle.space-between.m-top-2
      button.secondary-button(@click='closeModal') {{ $t("orderResourcesModal.cancel") }}
      button.primary-button(@click='submit') {{ $t("orderResourcesModal.save") }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '../Modal'
import dragIcon from '@/assets/ic_drag.svg'
import Draggable from 'vuedraggable'

export default {
  components: { Modal, Draggable },
  data() {
    return {
      dragIcon,
      resources: []
    }
  },
  created() {
    this.resources = this.modalProps.resources
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.orderResourcesModal.props
    })
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'orderFolderResources',
      'getFolderDetails'
    ]),
    closeModal() {
      this.hideElement({ element: 'orderResourcesModal' })
      if (this.modalProps.onClose) this.modalProps.onClose()
    },
    async submit() {
      this.showElement({ element: 'fullPageLoader' })
      if (this.modalProps.confirmFunc) this.modalProps.confirmFunc(this.resources.map((res, order) => ({ resourceId: res.id, order })))
      else {
        await this.orderFolderResources({
          folderId: this.$route.params.id,
          resources: this.resources.map((res, order) => ({ resourceId: res.id, order }))
        })
        await this.getFolderDetails(this.$route.params.id)
      }
      this.hideElement({ element: 'orderResourcesModal' })
      this.hideElement({ element: 'fullPageLoader' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.resources{
  height: 400px;
  overflow-y: auto;
  &>:not(:last-child){
    margin-bottom: 5px;
  }
}

.resource{
  cursor: grab;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid $gray;
  .name{
    user-select: none;
  }
  &.ghost{
    background-color: $light-gray;
  }
}

</style>
